<template>
  <div>
    <h4 class="mb-3 pb-3 border-bottom d-flex">
      {{ $t('customer.contact.comments') }}

      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="openCommentPopup({})">
        <i class="material-icons">add</i>
        {{ $t('customer.contact.addComment') }}
      </d-button>
    </h4>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('customer.contact.author') }}</th>
            <th scope="col" class="border-0">{{ $t('customer.contact.content') }}</th>
            <th scope="col" class="border-0 text-center">{{ $t('order.modificationDate') }}</th>
            <th scope="col" class="border-0 text-center" style="width: 130px;">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(comment, commentIndex) of comments"
            :key="'comment-' + commentIndex">
            <td class="align-middle">
              {{ comment.user_name }}
            </td>
              <td class="align-middle">
              {{ comment.description }}
            </td>
            <td class="align-middle text-center">
              {{ dateAsString(comment.updated_at) }}
            </td>
            <td class="align-middle text-center">
              <d-button
                theme="primary"
                :disabled="actionInProgress || (comment.user_id !== userID)"
                @click.native.prevent="openCommentPopup(comment)"
                :title="$t('ui.edit')"
                class="mr-2">
                <i class="material-icons">edit</i>
              </d-button>

              <d-button
                theme="danger"
                :disabled="actionInProgress || (comment.user_id !== userID)"
                @click.native.prevent="removeComment(comment.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="comments.length === 0">
            <td
              colspan="8"
              class="text-center">
              {{ $t('customer.contact.noCommentsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>
    </d-card>
    <comment-popup
      v-if="showCommentPopup"
      :contact-id="contactId"
      :comment-data="selectedComment"
      :user-id="userID" />
  </div>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import CommentPopup from '@/components/contacts/CommentPopup.vue';

export default {
  name: 'contact-comments',
  components: {
    'comment-popup': CommentPopup
  },
  props: {
    comments: {
      required: true,
      type: Array
    },
    contactId: {
      required: true,
      type: Number
    },
    isInOffer: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    userID () {
      return parseInt(this.$store.getters.getUserID, 10);
    }
  },
  data () {
    return {
      actionInProgress: false,
      selectedComment: {},
      showCommentPopup: false
    };
  },
  mounted () {
    this.$bus.$on('comment-popup-close', this.closeCommentPopup);
  },
  methods: {
    openCommentPopup (comment) {
      this.showCommentPopup = true;
      this.selectedComment = comment;
    },
    closeCommentPopup () {
      this.showCommentPopup = false;
    },
    removeComment (commentID) {
      this.actionInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/contacts/comments/delete/',
        id: commentID,
        successTitle: this.$t('customer.contact.removeCommentSuccessTitle'),
        successText: this.$t('customer.contact.removeCommentSuccessText'),
        confirmTitle: this.$t('customer.contact.removeCommentConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('customer.contact.removeCommentErrorText'),
        successAction: () => {
          this.actionInProgress = false;
          this.$bus.$emit('comments-reload-needed');
        },
        cancelAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    dateAsString (dateString) {
      if (!dateString) {
        return '';
      }

      let date = new Date(dateString);

      return [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
    },
  },
  beforeDestroy () {
    this.$bus.$off('comment-popup-close', this.closeCommentPopup);
  }
}
</script>
